import { type LinearConfigurationDTO } from "./Linear/dtos";
import { transform } from "./Linear/linearDataTransformer";
import { loadData } from "./Linear/redux/actions";
import { ConfiguratorPage } from "~/Configurators/common/components/ConfiguratorPage";
import { getAllConfiguratorDefinitions, registerConfiguratorDefinition } from "~/Configurators/configuratorRegistry";
import { CARRIAGE_DEFINITION } from "~/Configurators/Carriage/CarriageConfigurationPage";
import { KWLT_CARRIAGE_DEFINITION } from "./Carriage/v2/configuration/kwlt/KWLTCarriageConfigurationPage";
import { RAIL_DEFINITION } from "~/Configurators/Rail/v2/configuration/classic/RailConfigurationPage";
import { LC_DEFINITION } from "~/Configurators/Linear/LinearConfigurationPage";
import { METRIC_SHAFT_DEFINITION } from "~/Configurators/Shaft/MetricShaftConfiguratorDefinition";
import { IMPERIAL_SHAFT_DEFINITION } from "~/Configurators/Shaft/InchShaftConfiguratorDefinition";
import { getStore } from "~/redux/getStore";
import { trackLCStepStarted } from "~/Configurators/common/configuratorGA";
import { TKDM_RAIL_DEFINITION } from "./Rail/v2/configuration/tkdm/TKDMRailConfigurationPage";
import { TKLT_RAIL_DEFINITION } from "./Rail/v2/configuration/tklt/TKLTRailConfigurationPage";
import instance from "~/utils/i18n";
import { XML_TRANSLATION_SHEETS } from "./common/useXmlConfiguratorTranslations";

export function createConfiguratorPage(props: { data: string; helpUrl: string }) {
  const path = window.location.pathname;
  const productCode = path.match(/\d+/)?.[0];
  const configDefinition = getAllConfiguratorDefinitions().find((item) => item.productCode === productCode);
  if (!configDefinition) {
    console.error("No configurator definition available!");
    return null;
  }
  const configuratorType = configDefinition.type;

  const parsedData = JSON.parse(props.data) as LinearConfigurationDTO;
  const model = transform(parsedData, configuratorType);

  getStore().dispatch(loadData(model, props.helpUrl, configuratorType));

  if (model.highestVisitedStep === model.currentStep) {
    const sheetName = XML_TRANSLATION_SHEETS[configuratorType];
    instance.loadNamespaces(sheetName!.sheetName).then(() => {
      // index from model is 1 based, while in state it's 0 based
      trackLCStepStarted(configDefinition.productCode, model.currentStep - 1);
    });
  }

  return <ConfiguratorPage config={configDefinition} />;
}

registerConfiguratorDefinition(CARRIAGE_DEFINITION);
registerConfiguratorDefinition(KWLT_CARRIAGE_DEFINITION);
registerConfiguratorDefinition(RAIL_DEFINITION);
registerConfiguratorDefinition(TKDM_RAIL_DEFINITION);
registerConfiguratorDefinition(TKLT_RAIL_DEFINITION);
registerConfiguratorDefinition(LC_DEFINITION);

registerConfiguratorDefinition(METRIC_SHAFT_DEFINITION);
registerConfiguratorDefinition(IMPERIAL_SHAFT_DEFINITION);
